import Phaser from 'phaser';

/**
 * MainMenuScene - Title screen and main menu
 */
export class MainMenuScene extends Phaser.Scene {
  private music!: Phaser.Sound.BaseSound;

  constructor() {
    super({ key: 'MainMenuScene' });
  }

  create(): void {
    // Set up background music
    this.music = this.sound.add('menu_music', { loop: true, volume: 0.5 });

    // Handle browser autoplay policy - play when audio is unlocked
    if (this.sound.locked) {
      this.sound.once('unlocked', () => {
        this.music.play();
      });
    } else {
      this.music.play();
    }

    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // Title
    const title = this.add.text(width / 2, height / 3, 'BEASTIE-MASTER', {
      fontFamily: 'monospace',
      fontSize: '48px',
      color: '#4ade80', // Solarpunk green
      stroke: '#166534',
      strokeThickness: 4,
    });
    title.setOrigin(0.5);

    // Subtitle
    const subtitle = this.add.text(width / 2, height / 3 + 60, 'A Solarpunk Adventure', {
      fontFamily: 'monospace',
      fontSize: '18px',
      color: '#fbbf24', // Solar yellow
    });
    subtitle.setOrigin(0.5);

    // Start button
    const startButton = this.add.text(width / 2, height / 2 + 50, '[ START GAME ]', {
      fontFamily: 'monospace',
      fontSize: '24px',
      color: '#ffffff',
      backgroundColor: '#1e3a5f',
      padding: { x: 20, y: 10 },
    });
    startButton.setOrigin(0.5);
    startButton.setInteractive({ useHandCursor: true });

    startButton.on('pointerover', () => {
      startButton.setStyle({ backgroundColor: '#2d5a87' });
    });

    startButton.on('pointerout', () => {
      startButton.setStyle({ backgroundColor: '#1e3a5f' });
    });

    startButton.on('pointerdown', () => {
      this.startGame();
    });

    // Map Editor button
    const editorButton = this.add.text(width / 2, height / 2 + 110, '[ MAP EDITOR ]', {
      fontFamily: 'monospace',
      fontSize: '18px',
      color: '#888888',
      backgroundColor: '#1a1a2e',
      padding: { x: 15, y: 8 },
    });
    editorButton.setOrigin(0.5);
    editorButton.setInteractive({ useHandCursor: true });

    editorButton.on('pointerover', () => {
      editorButton.setStyle({ color: '#ffffff', backgroundColor: '#2d3748' });
    });

    editorButton.on('pointerout', () => {
      editorButton.setStyle({ color: '#888888', backgroundColor: '#1a1a2e' });
    });

    editorButton.on('pointerdown', () => {
      this.music.stop();
      this.scene.start('MapEditorScene');
    });

    // Version info
    this.add.text(10, height - 30, 'v0.1.0-dev', {
      fontFamily: 'monospace',
      fontSize: '12px',
      color: '#666666',
    });

    // Keyboard shortcut
    this.input.keyboard?.once('keydown-SPACE', () => {
      this.startGame();
    });

    this.input.keyboard?.once('keydown-ENTER', () => {
      this.startGame();
    });
  }

  private startGame(): void {
    this.music.stop();
    this.cameras.main.fadeOut(500, 0, 0, 0);
    this.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.start('GameScene');
    });
  }
}
